import React, { useState, FC, useContext } from 'react'
import { isEqual } from 'lodash'
import { Trans } from '@lingui/macro'
import { SaveDashboardFiltersButton } from '../../manage-campaign-page/components/SaveFiltersButton'
import { ManageDashboardPageContext } from '../manage/ManageDashboardPage'
import { DashboardAudienceTable } from './DashboardAudienceTable'
import CampaignFiltersList from '../../manage-campaign-page/components/campaign-audience/CampaignFiltersList'
import { AddAudienceFilterButton } from '../../manage-campaign-page/components/campaign-audience/AddAudienceFilterButton'

import IconFont from '../../../components/common/IconFont'
import { DashboardAudienceCheckPreview } from '../../../components/common/audience/AudienceCheckPreview'
import {
  DashboardFilterInput,
  CampaignFilterTypeEnum
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { NbSp } from 'front-end/src/utils/NbSp'
import { Box, ButtonLight } from 'front-end/src/components'
import { usePublicApiSession } from 'front-end/src/public-api/hooks/usePublicApiSession'

export const DashboardAudience: FC = () => {
  const { session } = usePublicApiSession()
  const { dashboard } = useContext(ManageDashboardPageContext)

  const [filters, setFilters] = useState<DashboardFilterInput[]>(
    // @ts-expect-error 9/11/2020
    dashboard.filters
  )
  const [showAudienceCheckPreview, setShowAudienceCheckPreview] =
    useState<boolean>(false)
  const isDirty = !isEqual(filters, dashboard.filters)

  return (
    <div className="CampaignAudience">
      <div className="CampaignAudience__header">
        <h2>
          <Trans>Define your target audience</Trans>
          <span>
            <Trans>
              Add filters below to refine your target audience for this
              dashboard
            </Trans>
          </span>
        </h2>
        <div className="CampaignAudience__header-controls">
          {isDirty && (
            <ButtonLight
              onClick={() => {
                // @ts-expect-error 9/11/2020
                setFilters(dashboard.filters)
              }}
            >
              <Trans>Cancel</Trans>
            </ButtonLight>
          )}
        </div>
      </div>

      <div className="CampaignAudience__filters">
        <CampaignFiltersList
          // @ts-expect-error 9/11/2020
          filters={filters}
          onUpdate={(updatedFilters) => {
            // @ts-expect-error 9/11/2020
            setFilters(updatedFilters)
          }}
        />
        <AddAudienceFilterButton
          className={'twoColumnWide'}
          // @ts-expect-error 9/11/2020
          onAdd={(filter: DashboardFilterInput) => {
            // @ts-expect-error 9/11/2020
            filter.created_at = new Date()
            filter.created_by = session?.user.id as number
            const updatedFilters = [...filters, filter]
            setFilters(updatedFilters)
          }}
          filterTypeCardsMap={{
            // @ts-expect-error 9/11/2020
            [CampaignFilterTypeEnum.value_comparison]: (
              <>
                <IconFont type="user-following" />

                <h3>
                  <Trans>Attribute</Trans>
                </h3>
                <small>
                  <Trans>Find people with a specific attribute</Trans>
                </small>
              </>
            ),
            // @ts-expect-error 9/11/2020
            [CampaignFilterTypeEnum.group]: (
              <>
                <IconFont type="people" />
                <h3>
                  <Trans>Group</Trans>
                </h3>
                <small>
                  <Trans>Select people who belong to a group</Trans>
                </small>
              </>
            )
          }}
        />
      </div>
      {filters.length === 0 && (
        <Box
          className="CampaignAudience__filters-save-cta CampaignAudience__filters-save-cta--warning"
          mb="24px"
        >
          <span className="CampaignAudience__filters-save-cta__icon">
            &#9888;
          </span>
          <NbSp />
          <Trans>Dashboard must have at least one audience filter</Trans>
        </Box>
      )}
      {isDirty && (
        <div className="CampaignAudience__filters-cta-wrapper">
          <div className="CampaignAudience__filters-save-cta">
            <span className="CampaignAudience__filters-audience-check-description">
              <Trans>
                You have made changes to your audience filters. Preview to see
                who will be added/removed, or save to apply your changes.
              </Trans>
            </span>
            <ButtonLight
              disabled={showAudienceCheckPreview}
              className="CampaignAudience__filters-preview-audience-btn"
              onClick={() => {
                setShowAudienceCheckPreview(true)
              }}
            >
              <Trans>Preview audience</Trans>
            </ButtonLight>
            <NbSp />
            <SaveDashboardFiltersButton
              // @ts-expect-error 9/11/2020
              filters={filters}
              dashboardId={dashboard.id}
            />
          </div>
          <div className="CampaignAudience__filters-audience-check-preview">
            {showAudienceCheckPreview && (
              <DashboardAudienceCheckPreview
                dashboardId={dashboard.id}
                // @ts-expect-error 9/11/2020
                filters={filters}
              />
            )}
          </div>
        </div>
      )}

      <DashboardAudienceTable />
    </div>
  )
}
